export default function ChevronRightIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 16.5858L13.5858 12.0001L9 7.41426L9 6.00004L9.00004 6L10.4142 6L15.7071 11.293L16.4142 12.0001L15.7071 12.7072L10.4142 18.0001L9 18.0001L9 16.5858Z"
        fill="var(--tertiary-color)"
        fillOpacity="0.5"
      />
    </svg>
  );
}
